import { render, staticRenderFns } from "./MigrainePathogenesis.vue?vue&type=template&id=6b3f2c0a&scoped=true&"
import script from "./MigrainePathogenesis.vue?vue&type=script&lang=js&"
export * from "./MigrainePathogenesis.vue?vue&type=script&lang=js&"
import style0 from "./MigrainePathogenesis.vue?vue&type=style&index=0&id=6b3f2c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3f2c0a",
  null
  
)

export default component.exports